export default __webpack_public_path__ + "static/media/banner.03e142e8.png";